export default {
  TRIAL_PLAN_EXPIRING: 'TRIAL_PLAN_EXPIRING',
  BASIC_PLAN_EXPIRING: 'BASIC_PLAN_EXPIRING',
  ALIGNER_CHECK_IN: 'ALIGNER_CHECK_IN',
  RESUME_TREATMENT_REMINDER: 'RESUME_TREATMENT_REMINDER',
  ALIGNER_CHANGED: 'ALIGNER_CHANGED',
  APPOINTMENT_REMINDER: 'APPOINTMENT_REMINDER',
  PRODUCTION_REMINDER: 'PRODUCTION_REMINDER',
  GENERAL_REMINDER: 'GENERAL_REMINDER',
  PAYMENT_REMINDER: 'PAYMENT_REMINDER',
  APPOINTMENT: 'APPOINTMENT',
  TREATMENT_START_REMINDER: 'TREATMENT_START_REMINDER',
  UNPROCESSED_ALIGNER_REMINDER: 'UNPROCESSED_ALIGNER_REMINDER',
}
